"use client"
import { Box, Typography, Paper, Container, FormControl, InputLabel, Select, MenuItem } from "@mui/material"
import { TEAM_MEMBERS } from "./constants/config"

export default function LoginView({ currentUser, setCurrentUser, onEnter }) {
  return (
    <Box
      sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "#ffffff" }}
    >
      <Container maxWidth="xs">
        <Paper elevation={0} sx={{ p: 5, textAlign: "center", border: "1px solid #e5e7eb", borderRadius: 3 }}>
          <Typography variant="h5" fontWeight="700" sx={{ color: "#111827", mb: 1 }}>
            VizPI Labeler
          </Typography>
          <Typography variant="body2" sx={{ color: "#6b7280", mb: 4 }}>
            Select your name to view sessions
          </Typography>
          <FormControl fullWidth sx={{ mb: 3, textAlign: "left" }}>
            <InputLabel>Researcher Name</InputLabel>
            <Select
              value={currentUser}
              label="Researcher Name"
              onChange={(e) => setCurrentUser(e.target.value)}
              sx={{ borderRadius: 2 }}
            >
              {TEAM_MEMBERS.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <button
            disabled={!currentUser}
            onClick={onEnter}
            style={{
              width: "100%",
              padding: "10px 0",
              borderRadius: "8px",
              backgroundColor: currentUser ? "#000000" : "#e5e7eb",
              color: currentUser ? "#ffffff" : "#9ca3af",
              border: "none",
              fontSize: "16px",
              fontWeight: 600,
              cursor: currentUser ? "pointer" : "not-allowed",
              transition: "background-color 0.2s",
            }}
            onMouseEnter={(e) => {
              if (currentUser) {
                e.target.style.backgroundColor = "#333333"
              }
            }}
            onMouseLeave={(e) => {
              if (currentUser) {
                e.target.style.backgroundColor = "#000000"
              }
            }}
          >
            Enter Workspace
          </button>
        </Paper>
      </Container>
    </Box>
  )
}